import React from "react";
import {PropTypes} from "prop-types";
import getDynamicImageUrl from "./getDynamicImageUrl";

const DynamicImage = ({options, alt, src, ...props}) => (
    <img {...props} alt={alt} src={getDynamicImageUrl(src, options)} />
);

DynamicImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    options: PropTypes.shape({
        crop: PropTypes.bool,
        width: PropTypes.number,
        smart: PropTypes.bool,
        height: PropTypes.number,
        grayscale: PropTypes.bool,
    }).isRequired,
};

export default DynamicImage;
